<template>
	<div class="full fixed top-0 left-0 w-full bg-white h-full z-[150] flexed flex-col justify-center">
		<div class="loader"></div>
	</div>
</template>

<script lang="ts" setup></script>

<style scoped>
	.loader {
		font-weight: bold;
		font-family: monospace;
		font-size: 30px;
		line-height: 1.2em;
		display: inline-grid;
	}
	.loader:before,
	.loader:after {
		content: 'Loading...';
		grid-area: 1/1;
		-webkit-mask: linear-gradient(90deg, #000 50%, #0000 0) 0 50%/2ch 100%;
		color: #094063;
		text-shadow: 0 0 0 #094063, 0 calc(var(--s, 1) * 1.2em) 0 #094063;
		animation: l15 1s infinite;
	}
	.loader:after {
		-webkit-mask-position: 1ch 50%;
		--s: -1;
	}
	@keyframes l15 {
		80%,
		100% {
			text-shadow: 0 calc(var(--s, 1) * -1.2em) 0 #094063, 0 0 0 #094063;
		}
	}
</style>
